import React from 'react'
import injectStyles from 'react-jss'
import { styles } from './styles'
import GenericFlatButton from '../../../../../../../../Components/GenericFlatButton'
import TriangleAlert from '../../../../../../../../Assets/Images/icons/TriangleAlert'
import { useState } from 'react'

const CancelModal = ({ onSubmit, onCancel, title, classes }) => {
  const [loading, setLoading] = useState(false)

  return (
    <div className={classes.container}>
      <div className={classes.icon}>{<TriangleAlert />}</div>
      {title && <div className={classes.title}>{title}</div>}

      <div className={classes.buttonContainer}>
        <GenericFlatButton
          type={'outline'}
          title={'Discard'}
          onClick={() => onCancel()}
        />
        <GenericFlatButton
          type={'filled'}
          title={'Confirm cancellation'}
          onClick={async () => {
            setLoading(true)
            await onSubmit()
            setLoading(false)
          }}
          loading={loading}
        />
      </div>
    </div>
  )
}
export default injectStyles(styles)(CancelModal)
